import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
  Button,
  Table,
  Space,
  Tooltip,
  message,
} from "antd";
import {
  SaveOutlined,
  EditOutlined,
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  CloseOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { BE_HOST } from "../../config/config";
import { countryCodes } from "../../data";
import { axiosInstance } from "../../utils/axiosInterceptor";

const UserPopupCompo = ({
  popupWithScrollViewVisible,
  hide,
  data,
  userRoleSource,
  isNewRecord,
  fetchUsers,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [accountsData, setAccountsData] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const token = localStorage.getItem("token");
  const [filterData, setFilterData] = useState([]);
  const [selectedCode, setSelectedCode] = useState("+1");
  const [isLoading,setIsLoading] = useState(false)
  const { Option } = Select;

  console.log(isNewRecord, "isNewRecord");
  const accountColumns = [
    {
      title: "Number",
      dataIndex: "acct_id",
      key: "acct_id",
      render: (text) => text || "-",
      ellipsis: true,
      width: 150,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => text || "-",
      ellipsis: true,
      width: 200,
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      render: (text) => text || "-",
      ellipsis: true,
      width: 150,
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      render: (text) => text || "-",
      ellipsis: true,
      width: 150,
    },
  ];
  const userDetails = JSON.parse(localStorage.getItem("userDetails") || null);
  const [userMappedAccounts, setUserMappedAccounts] = useState([]);
  // Add this state for search
  const [searchText, setSearchText] = useState("");
  // Add this function to filter accounts
  const filteredAccounts = accountsData.filter(
    (account) =>
      account.name?.toLowerCase().includes(searchText.toLowerCase()) ||
      account.acct_id
        ?.toString()
        .toLowerCase()
        .includes(searchText.toLowerCase())
  );

  const handleSearch = (value) => {
    console.log(value, "Value");
    setSearchText(value);
    const filtered = accountsData?.filter(
      (account) =>
        account.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        account.acct_id
          ?.toString()
          .toLowerCase()
          .includes(searchText.toLowerCase())
    );
    setFilterData(filtered);
  };
  // Update fetchAccountsData to also fetch user's mapped accounts
  const fetchAccountsData = React.useCallback(async () => {
    setLoading(true);
    try {
      const [, userAccountsResponse] = await Promise.all([
        axiosInstance
          .get(
            `/users/all-accounts`
          )
          .then((response) => {
            setAccountsData(response.data.data);
            setFilterData(response.data.data);
          }),
        !isNewRecord
          ? axiosInstance
              .get(
                `/users/accounts-by-userid?userId=${data.id}`
              )
              .then((response) => {
                return response.data?.data?.data?.accounts;
              })
          : Promise.resolve({ data: [] }),
      ]);

      const userAccounts = Array.isArray(userAccountsResponse)
        ? userAccountsResponse
        : [];
      // Change from acct_id to id here
      console.log("this is data", data);

      setSelectedAccounts(userAccounts.map((acc) => acc.id));
      setUserMappedAccounts(userAccounts);
    } catch (error) {
      // message.error("Failed to fetch accounts");
      setAccountsData([]);
      setSelectedAccounts([]);
      setUserMappedAccounts([]);
      setFilterData([]);
    } finally {
      setLoading(false);
    }
  }, [token, data?.id, isNewRecord]);

  const handleSaveAccounts = async () => {
    try {
      // Change from acct_id to id here
      const selectedAccountsData = accountsData.filter((account) =>
        selectedAccounts.includes(account.id)
      );

      if (selectedAccountsData.length > 0) {
        const res = await axiosInstance.post(
          `/users/map-multiple-account-to-user`,
          {
            // login_userId: userDetails.data.modify_user_id,
            userId: data?.id || null,
            // Send the selected account ids
            accountIds: selectedAccounts,
            // currentUserId: userDetails.data.modify_user_id,
            // removeUnselected: true, // Add flag to handle unselected accounts
          }
        );
        if (res) {
          message.success("Accounts mapped successfully");
          setEditMode(false);
          await fetchAccountsData(); // Refresh the data to show updated mappings
        }
      } else {
        setEditMode(false);
      }
    } catch (error) {
      console.error("Error mapping accounts:", error);
      message.error("Failed to map accounts");
    }
  };

  const baseData = searchText ? filterData : accountsData;

  const sortedData = [...baseData].sort((a, b) => {
    const aSelected = selectedAccounts.includes(a.id);
    const bSelected = selectedAccounts.includes(b.id);

    if (aSelected && !bSelected) return -1;
    if (!aSelected && bSelected) return 1;
    return 0;
  });
  console.log("token at the create user", token);

  const handleSubmit = async (value) => {
    //  console.log(value,"values")
    if (!!editMode) {
        message.info("Please first save changes");
        return;
      }
    const values = {
      email: value?.email,
      first_name: value?.first_name,
      last_name: value?.last_name,
      middle_name: value?.middle_name,
      phone: `${value?.countryCode}${value?.phone}`,
      send_email: value?.send_email,
      send_sms: value?.send_sms,
      user_roles_id: value?.user_roles_id,
    };
    const NewUserPayload = {
      user_roles_id: value?.user_roles_id,
      email: value?.email,
      first_name: value?.first_name,
      phone: `${value?.countryCode}${value?.phone}`,
      last_name:value?.last_name,
      accountIds: selectedAccounts
    }

    console.log(values, "valuessss");

    setIsLoading(true);
    try {
      if (isNewRecord) {
        await axiosInstance.post(`/api/v2/users/create-user`, NewUserPayload, {
        });
        message.success("User created successfully");
      } else {
        await axiosInstance.put(
          `/users/update?email=${values.email}`,
          values
        );
        message.success("User updated successfully");
      }
      fetchUsers();
      hide(); // Changed from onCancel to hide
    } catch (error) {
      message.error(error.response?.data?.data?.error || "Operation failed");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (popupWithScrollViewVisible) {
      if (data) {
        const sortedCodes = [...countryCodes].sort(
          (a, b) => b.code.length - a.code.length
        );

        let countryCode = "";
        let phoneNumber = "";

        if (data.phone) {
          if (data.phone.startsWith("+")) {
            const matched = sortedCodes.find((c) =>
              data.phone.startsWith(c.code)
            );
            if (matched) {
              countryCode = matched.code;
              phoneNumber = data.phone.replace(matched.code, "");
            } else {
              // fallback: take first 4 chars as code
              countryCode = data.phone.slice(0, 4);
              phoneNumber = data.phone.slice(4);
            }
          } else {
            phoneNumber = data.phone;
            countryCode = ""; // optional: set to '+91' as fallback
          }
        }

        form.setFieldsValue({
          ...data,
          countryCode,
          phone: phoneNumber,
        });
      } else {
        form.resetFields();
      }

      fetchAccountsData();
    } else {
      setEditMode(false);
    }
  }, [popupWithScrollViewVisible, data, form, fetchAccountsData]);

  console.log("Helloooooooooo");

  // Update handleCancel to reset form and editMode
  const handleCancel = () => {
    // form.resetFields();
    if (data) {
      const sortedCodes = [...countryCodes].sort(
        (a, b) => b.code.length - a.code.length
      );

      let countryCode = "";
      let phoneNumber = "";

      if (data.phone) {
        if (data.phone.startsWith("+")) {
          const matched = sortedCodes.find((c) =>
            data.phone.startsWith(c.code)
          );
          if (matched) {
            countryCode = matched.code;
            phoneNumber = data.phone.replace(matched.code, "");
          } else {
            // fallback: take first 4 chars as code
            countryCode = data.phone.slice(0, 4);
            phoneNumber = data.phone.slice(4);
          }
        } else {
          phoneNumber = data.phone;
          countryCode = ""; // optional: set to '+91' as fallback
        }
      }

      form.setFieldsValue({
        ...data,
        countryCode,
        phone: phoneNumber,
      });
    } else {
      form.resetFields();
    }
    setEditMode(false);
    setSelectedAccounts([]);
    setSearchText("");
    hide();
  };

  const newRecordAdd = ()=>{
    console.log(newRecordAdd,"newrecordasdddddd")
    setEditMode(false)
  }

  // Update Modal props
  return (
    <Modal
      style={{ marginTop: "-60px" }}
      title={
        <div
          style={{
            borderBottom: "1px solid #f0f0f0",
            padding: "16px 24px",
            marginLeft: -24,
            marginRight: -24,
            marginTop: -16,
            fontSize: "16px",
            fontWeight: 500,
            color: "#262626",
            display: "flex",
            alignItems: "center",
          }}
        >
          {isNewRecord ? "Add New User" : "Edit User Details"}
        </div>
      }
      open={popupWithScrollViewVisible}
      onCancel={handleCancel}
      width="80%"
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      className="user-modal"
      closeIcon={<CloseOutlined />}
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            borderTop: "1px solid #f0f0f0",
            padding: "16px 0",
            marginTop: "24px",
          }}
        >
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            loading={isLoading}
            onClick={() => form.submit()}
          >
            {isNewRecord ? "Create User" : "Save Changes"}
          </Button>
        </div>
      }
      styles={{
        padding: "24px",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "16px",
          }}
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, message: "Email is required" }]}
          >
            <Input
              style={{
                border: "1px solid var(--Primary-Dark-Blue, #000833)",
                height: "40px",
              }}
              prefix={<MailOutlined />}
              readOnly={!isNewRecord}
              placeholder="Enter email address"
            />
          </Form.Item>

          <Form.Item
            name="first_name"
            label="First Name"
            rules={[{ required: true }]}
          >
            <Input
              style={{
                border: "1px solid var(--Primary-Dark-Blue, #000833)",
                height: "40px",
              }}
              prefix={<UserOutlined />}
              placeholder="Enter first name"
            />
          </Form.Item>

          <Form.Item
            name="middle_name"
            label="Middle Name"
            // rules={[{ required: true }]}
          >
            <Input
              style={{
                border: "1px solid var(--Primary-Dark-Blue, #000833)",
                height: "40px",
              }}
              prefix={<UserOutlined />}
              placeholder="Enter middle name"
            />
          </Form.Item>

          <Form.Item
            name="last_name"
            label="Last Name"
            rules={[{ required: true }]}
          >
            <Input
              style={{
                border: "1px solid var(--Primary-Dark-Blue, #000833)",
                height: "40px",
              }}
              prefix={<UserOutlined />}
              placeholder="Enter last name"
            />
          </Form.Item>

          <Form.Item
            name="user_roles_id"
            label="User Role"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select Role"
              style={{
                border: "1px solid var(--Primary-Dark-Blue, #000833)",
                height: "40px",
                "border-radius": "6px",
              }}
            >
              {userRoleSource?.map((role) => (
                <Select.Option key={role.id} value={role.id}>
                  {role.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Mobile Phone" required style={{ marginBottom: 16 }}>
            <Input.Group compact>
              <Form.Item
                name="countryCode"
                noStyle
                initialValue={selectedCode}
                rules={[
                  { required: true, message: "Country code is required" },
                ]}
              >
                <Select
                  style={{ width: "30%" }}
                  onChange={(value) => setSelectedCode(value)}
                  value={selectedCode}
                  showSearch
                  className="h-[40px] border-[1px] border-black remove-caret"
                  dropdownMatchSelectWidth={false} 
                  popupClassName="custom-country-dropdown  " 
                >
                  {countryCodes.map((country) => (
                    <Option key={country.label} value={country.code}>
                      <div className="flex justify-start w-[200px]">
                        <span style={{ paddingRight: 10,width:"50px" }}>
                          {country.code}{" "}
                        </span>
                        <span className="text-gray-400 ml-2">
                          {country?.iso}
                        </span>
                      </div>
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="phone"
                noStyle
                rules={[
                  {
                    required: true,
                    message: "Please enter your mobile number",
                  },
                  {
                    pattern: /^[0-9]{8,15}$/,
                    message: "Enter a valid Number",
                  },
                ]}
              >
                <Input
                  style={{
                    width: "calc(70%)",
                    border: "1px solid var(--Primary-Dark-Blue, #000833)",
                    height: "40px",
                  }}
                  prefix={<PhoneOutlined />}
                  placeholder="Enter phone number"
                />
              </Form.Item>
            </Input.Group>
          </Form.Item>

          {/* <Form.Item
            name="phone"
            label="Mobile Phone"
            rules={[{ required: true }]}
          >
            <Input
              style={{
                border: "1px solid var(--Primary-Dark-Blue, #000833)",
                height: "40px",
              }}
              prefix={<PhoneOutlined />}
              placeholder="Enter phone number"
            />
          </Form.Item> */}

          {isNewRecord && (
            <>
              {/* <Form.Item
                name="password"
                label="Password"
                rules={[{ required: true }]}
              >
                <Input.Password
                  prefix={<KeyOutlined />}
                  placeholder="Enter password"
                />
              </Form.Item> */}

              {/* <Form.Item
                name="confirm_password"
                label="Confirm Password"
                dependencies={["password"]}
                rules={[
                  { required: true },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject("Passwords do not match");
                    },
                  }),
                ]}
              >
                <Input.Password
                  prefix={<KeyOutlined />}
                  placeholder="Confirm password"
                />
              </Form.Item> */}
            </>
          )}

          <Form.Item name="send_email" valuePropName="checked">
            <Checkbox>Send Email</Checkbox>
          </Form.Item>

          <Form.Item name="send_sms" valuePropName="checked">
            <Checkbox>Send SMS</Checkbox>
          </Form.Item>
        </div>

        <div style={{ marginTop: "24px" }}>
          <Space
            style={{
              marginBottom: "16px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h5>Accounts</h5>
            <Input
              placeholder="Search by Account Number or name"
              allowClear
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: 400 }}
              prefix={<SearchOutlined />}
            />
            {/* {data && ( */}
              <Tooltip title={editMode ? "Save Changes" : "Edit Accounts"}>
                <Button
                  icon={editMode ? <SaveOutlined /> : <EditOutlined />}
                  onClick={() =>
                    editMode ? isNewRecord ? newRecordAdd() : handleSaveAccounts() : setEditMode(true)
                  }
                >
                  {editMode ? "Save" : "Edit"}
                </Button>
              </Tooltip>
            {/* ) */}
            {/* // } */}
          </Space>

          <Table
            loading={loading}
            columns={accountColumns}
            dataSource={
              // isNewRecord
              // searchText ? filterData : accountsData
              sortedData
              //   : editMode
              // ?
              // filteredAccounts

              // : userMappedAccounts
            }
            rowSelection={
              editMode
                ? {
                    type: "checkbox",
                    selectedRowKeys: selectedAccounts,
                    // onChange: (keys) => {
                    //   // setSelectedAccounts(keys);
                    // },
                    onSelect: (record, selected) => {
                      setSelectedAccounts((prev) => {
                        if (selected) {
                          return [...prev, record.id];
                        } else {
                          return prev.filter((id) => id !== record.id);
                        }
                      });
                    },
                    onSelectAll: (selected, selectedRows, changeRows) => {
                      setSelectedAccounts((prev) => {
                        if (selected) {
                          const newKeys = changeRows.map((r) => r.id);
                          return Array.from(new Set([...prev, ...newKeys]));
                        } else {
                          const removeKeys = changeRows.map((r) => r.id);
                          return prev.filter((id) => !removeKeys.includes(id));
                        }
                      });
                    },
                    preserveSelectedRowKeys: false,
                  }
                : null
            }
            rowClassName={(record) => {
              // Change from acct_id to id here
              return (userMappedAccounts.some((acc) => acc.id === record.id) || selectedAccounts?.some((id) => id === record?.id))
                ? "ant-table-row-selected"
                : "";
            }}
            size="small"
            scroll={{ y: 400 }}
            // Change from acct_id to id here
            rowKey={(record) => record.id}
          />
        </div>
      </Form>
      <style>
        {`.custom-country-dropdown {
          width: 220px !important; 
          }
          .remove-caret .ant-select-selection-search input {
  caret-color: transparent !important;
  // color: transparent !important;     
  background-color: transparent;       
}     
`}
      </style>
    </Modal>
  );
};

export default UserPopupCompo;
